import { GuiBase } from "../GuiBase";

/** DEVCLR-352: Support-Dashboard - nur GuiBase (Toasts, Tooltips, Logout-Timer), keine eigenen Events. */
export class GuiSupportDashboard extends GuiBase {

    constructor() {
        super("SupportDashboard");
    }
}
